<template lang="pug">
    el-dialog(:title="!coachForm.id ? '新增教练': '修改教练'" width="95%" :visible.sync='visible' :modal-append-to-body='false' :append-to-body='true' @close="closeForm()")
      el-form(:model="coachForm" :inline="false" :rules="rules" ref="coachFormRef" label-width="90px" label-position='right' @submit.native.prevent)
          el-card(shadow="never")
            div
                el-form-item(label="姓名:" prop="name" )
                    el-input.inputWidths(v-model='coachForm.name' clearable )
                el-form-item(label="手机号码:" prop="phone")
                     el-input.inputWidths(v-model='coachForm.phone'    placeholder="请填写手机号码" type="text" )
                el-form-item(label="身份证号:" prop="cardNum")
                    el-input.inputWidths(v-model='coachForm.cardNum'   type="text" )
                el-form-item(label="主办方:" prop="userGroupId")
                    el-select.inputWidths(v-model='coachForm.userGroupId'  placeholder="请选择主办方" filterable clearable @change="changeCity")
                        el-option(v-for="(item,index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId" )
                //- el-form-item(label="身份证号:" prop="cardNum")
                //-     el-input.inputWidths(v-model='coachForm.cardNum'   type="text" )
                el-form-item(label="地区:" prop="city")
                    el-col(style="width:20%;")
                        el-input(v-model="coachForm.provinceName" v-show="false")
                        el-select(v-model="coachForm.provinceCode" placeholder="请选择省" style="width:100%;" :disabled="cityDisbaled" @change="changeProvice")
                            el-option(v-for="(item,index) in provinceList" :key="index" :label="item.name" :value="item.code" )
                    el-col(style="width:2%;" class="line") &nbsp;&nbsp;省&nbsp;&nbsp;
                    el-col(style="width:20%;")
                        el-input(v-model="coachForm.cityName" v-show="false")
                        el-select(v-model="coachForm.cityCode" placeholder="请选择市" style="width:100%;" :disabled="provinceDisabled" @change="selectCity")
                            el-option(v-for="(item,index) in cityList" :key="index" :label="item.cityname" :value="item.citycode" )
                    el-col(style="width:20%;") &nbsp;&nbsp;市&nbsp;

                el-form-item(label="等级:" prop="leve" placeholder="请输入等级")
                    el-input.inputWidths(v-model='coachForm.leve'   type="text" )
                el-form-item(label="级别:" prop="coachLevel")
                    el-select.inputWidths( v-model='coachForm.coachLevel' clearable)
                        el-option(v-for="(item,index) in levelOptions" :label="item.label" :value="item.value" )
                el-form-item(label="性别:" prop="sex" )
                    el-radio-group(v-model="coachForm.sex")
                        el-radio(label="0") 男
                        el-radio(label="1") 女
                el-form-item(label="邮箱:" prop="email" )
                    el-input.inputWidths(v-model='coachForm.email' clearable)
                    //- 迭代二
                el-form-item(label="授课时数:" prop="classHours")
                    el-input.inputWidths(v-model='coachForm.classHours' placeholder="请填写授课时长"  type="text" )
                el-form-item(label="教练资质:" prop="intelligence")
                    el-input.inputWidths(v-model='coachForm.intelligence' placeholder="请填写教练资质，多个请用,号隔开"  type="text" )
                //- el-form-item(label="add课时费标准:" prop="cardNum")
                //-     el-input.inputWidths(v-model='coachForm.cardNum'   type="text" )
                el-form-item(label="教练标签:" prop="roleLimits")
                  el-checkbox-group(v-model="coachForm.roleLimits" @change="genderLimitChange")
                      el-checkbox(label="专业") 专业
                      el-checkbox(label='效率高') 效率高
                      el-checkbox(label='认真负责') 认真负责
                      //- el-checkbox(:label='4') 志愿者
                      //- el-checkbox(:label='5') 家长
                      //- el-checkbox(:label='6') 其他
                el-form-item(label="教练头像:" prop="headPortrait")
                    el-input(v-model="coachForm.headPortrait" v-show="false")
                      //- el-upload(:http-request="uploadFileList",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                      //-     img(v-if="listImageUrl" :src="listImageUrl" class="avatar" style="width:245px;height:178px;" )
                      //-     i(v-else class="el-icon-plus avatar-uploader-icon" style="width:245px;height:178px;" )
                    img(v-if="listImageUrl" :src="listImageUrl" class="avatar" @click="openImgdailog(1)" style='width:100px;height:100px')
                    i(v-else class="el-icon-plus avatar-uploader-icon" style="width:100px;height:100px;" @click="openImgdailog(1)")
                    imgupload2M(v-if="openImg_l" ref="upimg_l" :width="100" :height="100" @uploadSuccess='doneup_l')
                    el-alert(title="建议最小分辨率100×100,上传图片格式仅支持jpg,jpeg,png,大小不超过2M" effect='light' :closable="false")
                el-form-item(label="运动经历:" prop="sportsExperience")
                    d2-quill(ref="d2-quill" v-model="coachForm.sportsExperience"  style="min-height: 200px;")
      span.dialog-footer(slot="footer")
          el-button(type="primary" @click="coachFormSubmit()" :disabled="clickFlag") 确 定
          el-button(@click="closeForm()") 取 消
</template>
<script>
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        // alert(1)
        callback(new Error('必须填写运动经历!'))
      } else {
        if (this.coachForm.sportsExperience === '<p><br></p>') {
          callback(new Error('必须填写运动经历!'))
        }
        callback()
      }
    }
    return {
      clickFlag: false,
      sysOrgList: [],
      cityDisbaled: true,
      provinceDisabled: true,
      cityList: [],
      coachForm: {
        id: null,
        name: '',
        phone: '',
        cardNum: '',
        userGroupId: '',
        provinceName: '',
        provinceCode: '',
        cityName: '',
        cityCode: '',
        leve: '',
        coachLevel: '',
        sex: '',
        email: '',
        level: '',
        roleLimits: [],
        sportsExperience: '',
        classHours: '',
        intelligence: '',
        headPortrait: ''
      },
      flagType: '',
      loading: null,
      provinceList: [],
      levelOptions: [
        { value: '0.0', label: '0.0' },
        { value: '1.0', label: '1.0' },
        { value: '1.5', label: '1.5' },
        { value: '2.0', label: '2.0' },
        { value: '2.5', label: '2.5' },
        { value: '3.0', label: '3.0' },
        { value: '3.5', label: '3.5' },
        { value: '4.0', label: '4.0' },
        { value: '4.5', label: '4.5' },
        { value: '5.0', label: '5.0' }
      ],
      rules: {
        name: [
          { required: true, message: '名字不能为空!', trigger: 'blur' },
          { max: 20, message: '长度不能超过20个字符!' }
        ],
        phone: [
          { required: true, message: '手机号码不能为空!', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码输入有误',
            trigger: 'blur'
          }
        ],
        cardNum: [
          { required: true, message: '身份证号不能为空!', trigger: 'blur' },
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '身份证号有误',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: false,
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/,
            message: '邮箱输入有误',
            trigger: 'blur'
          }
        ],
        userGroupId: [
          { required: true, message: '主办方不能为空!', trigger: 'blur' }
        ],
        coachLevel: [
          { required: true, message: '级别不能为空!', trigger: 'blur' }
        ],
        sex: [{ required: true, message: '必须选择性别!', trigger: 'blur' }],
        roleLimits: [
          { required: true, message: '必须选择教练标签!', trigger: 'change' }
        ],
        sportsExperience: [
          { required: true, validator: validatePass, trigger: 'change' }
        ],
        intelligence: [
          { required: true, message: '必须填写教练资质!', trigger: 'blur' }
        ],
        classHours: [
          { required: true, message: '必须填写授课时数!', trigger: 'blur' }
        ],
        headPortrait: [
          { required: true, message: '必须上传头像!', trigger: 'change' }
        ],
        level: [{ message: '比赛级别不能为空!', trigger: 'change' }]
        // headPortrait: []
      },
      visible: false,
      listImageUrl: '',
      openImg_l: false
    }
  },
  mounted () {
    //this.restaurants = this.loadAll()
    this.initCity()
  },
  watch: {
    'coachForm.sportsExperience' () {
      this.$nextTick(() => {
        this.$refs.coachFormRef.validateField('sportsExperience')
      })
    }
  },
  methods: {
    init (id, flagType) {
      this.$nextTick(() => {
        this.$refs['coachFormRef'].clearValidate()
      })
      this.clickFlag = false
      this.flagType = flagType
      this.coachForm.id = id || null
      this.visible = true
      this.$nextTick(() => {
        this.$refs['coachFormRef'].resetFields()
      })
      //数据初始化
      this.coachForm.level = ''
      this.selClear()
      this.cityDisbaled = true
      this.provinceDisabled = true
      // this.coachForm.roleLimits = []
      // this.dataInit()
      //修改回选
      if (this.coachForm.id) {
        this.$http({
          url: this.$http.adornUrl(`/pxCoach/getId/` + this.coachForm.id),
          method: 'get'
        }).then((data) => {
          if (data && data.code === 0) {
            this.changeCity(data.bean.userGroupId)
            data.bean.sex = data.bean.sex + ''
            data.bean.roleLimits = data.bean.label.split(',')
            this.coachForm = data.bean
            // this.coachForm.roleLimits = ['专业', '效率高', '认真负责']
            console.log(this.coachForm.roleLimits)
            this.listImageUrl = data.bean.headPortrait
            this.$refs['d2-quill'].Quill.pasteHTML(data.bean.sportsExperience)
            this.changeProvice(0)
            this.selectCity(0)
          }
        })
      }
    },
    selectCity () { },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //新增方法
    coachFormSubmit () {
      console.log(this.coachForm)
      this.$refs['coachFormRef'].validate((valid) => {
        console.log(this.coachForm)
        if (valid) {
          this.openFullScreen()
          this.clickFlag = true
          this.$http({
            url: this.$http.adornUrl(
              `/pxCoach/${!this.coachForm.id ? 'save' : 'update'}`
            ),
            method: 'post',
            data: this.coachForm
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.flagType = 1
                  this.visible = false
                  this.clickFlag = false
                  this.$emit('refreshDataList')
                  this.loading.close()
                }
              })
            } else {
              this.$message.error(data.msg)
              this.loading.close()
            }
          })
        }
      })
    },
    closeForm () {
      if (this.flagType === 2) {
        this.$http({
          url: this.$http.adornUrl(`/pxCoach/delete/` + this.coachForm.id),
          method: 'get'
        }).then((data) => {
          this.visible = false
        })
      } else {
        this.visible = false
      }
    },
    // 图片上传
    openImgdailog (val) {
      let picType = 'trainDetailPic'
      let upimg = 'upimg_l'
      console.log(val)
      // const isLt2M = val.size / 1024 / 1024 < 2
      if (val === 1) {
        this.openImg_l = true
        picType = 'trainTablePic'
        upimg = 'upimg_l'
      }
      // if (val === 2) {
      //   this.openImg_d = true
      //   picType = 'trainDetailPic'
      //   upimg = 'upimg_d'
      // }
      this.$nextTick(() => {
        console.log(picType)
        this.$refs[upimg].init(picType) //传入图片类型参数
      })
    },
    // 上传完成
    doneup_l (val, url) {
      console.log(val, 88)

      this.coachForm.headPortrait = val
      this.listImageUrl = url
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    selClear () {
      this.coachForm.cityCode = ''
      this.coachForm.cityName = ''
      this.cityList = []
      this.coachForm.provinceCode = ''
      this.coachForm.provinceName = ''
    },
    changeProvice (flag) {
      if (flag !== 0) {
        this.cityList = []
        this.coachForm.cityCode = ''
      }
      this.$http({
        url: this.$http.adornUrl('/dicProvinceCity/queryByOrgId'),
        method: 'get',
        params: this.$http.adornParams({
          orgId: this.coachForm.userGroupId,
          provinceCode: this.coachForm.provinceCode
        })
      }).then((data) => {
        let obj = {}
        let val = this.coachForm.provinceCode
        if (val) {
          obj = this.provinceList.find((item) => {
            return item.code === val
          })
          if (obj) {
            this.coachForm.provinceName = obj.name
          }
        }
        this.cityList = data.list
      })
    },
    changeCity (val) {
      this.selClear()
      if (val === '' || val === null) {
        this.cityDisbaled = true
        this.provinceDisabled = true
        return
      } else {
        this.cityDisbaled = false
        this.provinceDisabled = false
      }
      this.getById(val)
    },
    genderLimitChange (label) {
      console.log(this.coachForm.roleLimits)
      console.log(label)
      this.coachForm.label = this.coachForm.roleLimits.join()
      console.log(this.coachForm.label)
      // this.choseloabellabel(label)
    },
    choseloabellabel (label) {
      let str = label
      let come = []
      let item = ''
      for (let i = 0; i < str.length; i++) {
        if (str[i] === 1) {
          come[i] = '专业'
        }
        if (str[i] === 2) {
          come[i] = '效率高'
        }
        if (str[i] === 3) {
          come[i] = '认真负责'
        }
        if (i === 0) {
          item = come[i]
        } else {
          item = item + ',' + come[i]
        }
      }
      // console.log(come)
      this.coachForm.label = item
      // console.log(this.coachForm.label)
    },
    //获取省和市
    getById (val) {
      this.$http({
        url: this.$http.adornUrl(`/dicProvince/queryByOrgId/` + val),
        params: this.$http.adornParams({
          orgId: val
        }),
        method: 'get'
      }).then((data) => {
        if (data && data.code === 0) {
          this.provinceList = data.list
        }
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getLeftData()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getLeftData()
    },
    checkAll (val) {
      this.nowSelectData = val
    }
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.inputWidths {
  width: 20%;
}

.font_later {
  padding-left: 20px;
  font-weight: bold;
  color: #909399;
}
.font_color {
  font-weight: bold;
  color: #909399;
}
.font_style {
  font-weight: bold;
  color: red;
}
.dialog-footer {
  padding-bottom: 150px;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}

/* 弹出遮罩层 兼容ie*/
.el-dialog__wrapper {
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}
</style>
